import { render, staticRenderFns } from "./AdminFeedbackConnect.vue?vue&type=template&id=334711ef&scoped=true"
import script from "./AdminFeedbackConnect.vue?vue&type=script&lang=ts"
export * from "./AdminFeedbackConnect.vue?vue&type=script&lang=ts"
import style0 from "./AdminFeedbackConnect.vue?vue&type=style&index=0&id=334711ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334711ef",
  null
  
)

export default component.exports